export const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
